<!--
 Copyright (c) Qwoach LLC 2020. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 8/25/20
-->

<template>
	<FormElementTemplate
		:formElement="formElement"
		:viewMode="viewMode"
		v-bind="$attrs">

		<template #body>
			<FormDateRow
				class="form-answer"
				:class="{'form-answer-edit': isEditMode, 'form-answer': !isEditMode, 'hide-placeholders-on-print': isEditMode}"
				v-model="formElement.answer"
				:readonly="!isAnswerMode"
				:borderDotted="!isAnswerMode"
				:placeholder="answerPlaceholder"
				:disable-future-dates="formElement._disableFutureDates"
				:defaultValue="defaultValueDate"
				initialView="year"
				@change="$emit('change', formElement)"
			/>

			<FormTextRow
				v-if="isEditMode"
				:class="{'form-answer-edit': isEditMode, 'form-answer': !isEditMode, 'hide-placeholders-on-print': isEditMode}"
				:borderDotted="isEditMode"
				:readonly="true"
				:force-show-when-empty="true"
				:placeholder="answerPlaceholder"
				class="form-answer"/>


		</template>

	</FormElementTemplate>
</template>

<script>

import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseFormElement from "@/core/modules/coach/Resources/Forms/FormElements/BaseFormElementView.vue";
import FormElementTemplate from "@/core/modules/coach/Resources/Forms/FormElements/FormElementTemplate.vue";

import FormDateRow from "@/core/components/Form/FormDateRow.vue";
import FormElementDateOfBirth
	from "@/core/modules/coach/Resources/Forms/model/FormElements/Smart/FormElementDateOfBirth";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import dayjs from "dayjs";
import FormElementDate from "@/core/modules/coach/Resources/Forms/model/FormElements/General/FormElementDate";

export default {
	name: "FormElementDateView",
	components: {FormTextRow, FormDateRow, FormElementTemplate},
	extends: BaseFormElement,
	props: {
		formElement: [FormElementDate, FormElementDateOfBirth]
	},

	data() {
		return {
		}
	},


	methods: {

	},

	computed: {
		answerPlaceholder() {
			// if (this.isViewMode) {
			// 	return "Your answer"
			// }
			// switch (this.formElement.type) {
			// 	case FormElementType.MULTILINE:
			// 		return "Answer text"
			// }
			// return "Short answer text"
			if(this.isAnswerMode){
				return "Click to select date"
			}
			if(this.isViewMode){
				return "No date provided"
			}
			return "Client's answer"
		},

		isMultiline(){
			return this.formElement.type === FormElementType.MULTILINE
		},

		defaultValueDate(){
			return dayjs().add("-30", "year").toDate()
		}

	}

}
</script>

<style>

</style>
